"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveIcon = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const ArchiveIcon = ({ fill, size, title = "Archive" }) => (react_1.default.createElement(Base_1.Base, { size: size ? size : 16, smooth: true },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { fill: fill ? fill : "#E6E6E6", d: "M4 5v1.4l5.8 5.8L8 14h5V9l-1.8 1.8L5.4 5H4zm5-3v4h4L9 2zM2 1h8l4 4v10H2V1z" })));
exports.ArchiveIcon = ArchiveIcon;
//# sourceMappingURL=Archive.js.map